import React, { Fragment, useEffect } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import CategoryProgramPost from '../../../Component/Learning/CategoryProgram/CategoryProgramPost';
import { useParams } from 'react-router-dom';
import { handleEditCategoryProgram } from '../../../Component/Learning/CategoryProgram/CategoryProgramUtils';
import { setField, resetState } from '../../../Features/Learning/CategoryProgram/addCategoryProgramSlice';
import { fetchCategoryProgram } from '../../../Features/Learning/CategoryProgram/Utils/CategoryProgramUtils';

const CategoryProgramAdd = () => {
  const addField = useSelector(state => state.addCategoryProgram)
  const dispatch = useDispatch();
  const filters = useSelector(state => state.CategoryProgram.filters)
  const { id } = useParams();

  useEffect(() => {
    if (!addField.id && id) {
      const newFilters = {
        ...filters,
        "filter[id]": id,
        "page": 1,
      };
      dispatch(fetchCategoryProgram(newFilters))
        .then((response) => {
          const item = response?.payload?.data?.[0];
          if (!item) {
            console.error('Category Program tidak ditemukan untuk id:', id);
            return;
          }
          handleEditCategoryProgram(dispatch, item, setField);
        })
        .catch((error) => {
          console.error('Error during fetchCategoryProgram:', error);
        });
    } else if (!id) {
      dispatch(resetState());
      // console.log(addField, "addField");
    }
  }, [id]);

  return (
    <Fragment>
      <Breadcrumbs parent="Category Program" title={id ? "Update Category Program" : "Tambah Category Program"} />
      <CategoryProgramPost />
    </Fragment>
  );
};

export default CategoryProgramAdd;
